"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logPageView = exports.logEvent = exports.initGA = void 0;
var _reactGa = _interopRequireDefault(require("react-ga4"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var initGA = googleAnalyticsTrackingCode => {
  _reactGa.default.initialize(googleAnalyticsTrackingCode);
};
exports.initGA = initGA;
var logPageView = (url, pageTitle) => {
  var sanitizedURL = url;
  if (url.endsWith('/')) {
    sanitizedURL = url.slice(0, -1);
  }
  _reactGa.default.send({
    hitType: 'pageview',
    page: sanitizedURL,
    title: pageTitle
  });
};

// TODO: Improve type
exports.logPageView = logPageView;
var logEvent = event => {
  _reactGa.default.event(event);
};
exports.logEvent = logEvent;